import { Grid, withStyles } from "@mui/material";
import React, { useState } from "react";
import Chip from "../../../../components/Chip";
import { RapportDossierParticulier } from "../../../../services/Api/swagger";
import styles from "../../SyntheseDossierLocationPage/Synthese/styles";
import CalculLocataire from "./CalculLocataire";

interface Props {
  classes?: any;
  data?: RapportDossierParticulier[];
  typeDossier: string;
}

interface State {
  personSelected: string;
}

function CalculLocataires({ data, typeDossier }: Props) {
  const defaultPersonSelected = data && data[0] && data[0].reference;

  const [personSelected, setPersonSelected] = useState<string | undefined>(
    defaultPersonSelected
  );

  const handleSelectPerson = (id: string) => {
    setPersonSelected(id);
  };

  if (data && data.length > 0) {
    const findPersonSelected = personSelected
      ? data.find((person) => person.reference === personSelected)
      : data[0];
    const isConjoint =
      (findPersonSelected &&
        typeDossier === "COUPLE" &&
        !findPersonSelected.principal) ||
      false;
    return (
      <Grid
        sx={styles}
        container
        alignItems="flex-start"
        justifyContent="flex-start"
        className={"candidats"}
      >
        {data.length === 1 && typeDossier === "SEUL" ? (
          <CalculLocataire isConjoint={false} personne={data[0]} />
        ) : (
          <>
            <Grid container wrap="nowrap" alignItems="flex-start">
              <div className={"contentChips"}>
                {/* Selection de la personne */}
                {data.map((personne, i) => {
                  let nomCandidat =
                    "Candidat(e)" +
                    " " +
                    personne.prenomLocataire +
                    " " +
                    personne.nomLocataire;
                  if (typeDossier === "COUPLE" && !personne.principal) {
                    nomCandidat =
                      "Conjoint(e)" +
                      " " +
                      personne.prenomLocataire +
                      " " +
                      personne.nomLocataire;
                  }
                  return (
                    <Chip
                      active={personSelected === personne.reference}
                      key={i}
                      onClick={handleSelectPerson}
                      label={nomCandidat}
                      id={personne.reference || ""}
                    />
                  );
                })}
              </div>
            </Grid>
            <CalculLocataire
              isConjoint={isConjoint}
              personne={findPersonSelected}
            />
          </>
        )}
      </Grid>
    );
  }
  return null;
}

export default CalculLocataires;
